export const FEED_PH_RANGES = {
  soft: { min: 0, max: 13.9 },
  hard: { min: 0, max: 14 },
};

export const CALCULATED_PH_TEMP = 25; // 25 degree
